export function MonogramK({ size = 36, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Kubwalo monogram">
      <defs>
        <linearGradient id={`gold-grad-${size}`} x1="0" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
          <stop stopColor="#D4AF37" />
          <stop offset="0.5" stopColor="#FFF4B8" />
          <stop offset="1" stopColor="#AA771C" />
        </linearGradient>
      </defs>
      <path d="M25 15V85M25 50L75 15M35 40L80 85" stroke={`url(#gold-grad-${size})`} strokeWidth="6" strokeLinecap="square" />
    </svg>
  );
}

export function LogoWordmark({ compact = false }) {
  return (
    <span className="flex items-center gap-3" data-testid="brand-logo">
      <MonogramK size={compact ? 26 : 34} />
      <span className="flex flex-col leading-none">
        <span className={`font-serif-display gold-text font-medium tracking-[0.3em] ${compact ? "text-base" : "text-lg sm:text-xl"}`}>
          KUBWALO
        </span>
        <span className="font-sans-body text-[8px] sm:text-[9px] uppercase tracking-[0.55em] text-[#C6A15B] mt-1">
          Fragrances
        </span>
      </span>
    </span>
  );
}

export function ProductImagePlaceholder({ name, className = "" }) {
  return (
    <div className={`relative flex flex-col items-center justify-center bg-[#0D0D0D] ${className}`} data-testid="product-image-placeholder">
      <div className="absolute inset-0 opacity-40" style={{ background: "radial-gradient(ellipse at 50% 40%, rgba(212,175,55,0.18), transparent 65%)" }} />
      <svg width="90" height="90" viewBox="0 0 120 120" fill="none" className="relative opacity-90">
        <defs>
          <linearGradient id="ph-gold" x1="0" y1="0" x2="120" y2="120" gradientUnits="userSpaceOnUse">
            <stop stopColor="#D4AF37" />
            <stop offset="0.5" stopColor="#FFF4B8" />
            <stop offset="1" stopColor="#AA771C" />
          </linearGradient>
        </defs>
        <path d="M60 6 L96 24 L114 60 L96 96 L60 114 L24 96 L6 60 L24 24 Z" stroke="url(#ph-gold)" strokeWidth="1.5" fill="none" />
        <path d="M42 36V84M42 60L78 36M50 52L84 84" stroke="url(#ph-gold)" strokeWidth="4" strokeLinecap="square" />
      </svg>
      <span className="relative mt-4 font-sans-body text-[9px] uppercase tracking-[0.5em] text-[#C6A15B]">
        Kubwalo Private Blend
      </span>
      <span className="relative mt-2 font-serif-display italic text-sm text-[#B8B8B8]">{name}</span>
    </div>
  );
}
